import { render, staticRenderFns } from "./context-menu.base.vue?vue&type=template&id=4fb5c646&scoped=true"
import script from "./context-menu.base.vue?vue&type=script&lang=js"
export * from "./context-menu.base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb5c646",
  null
  
)

export default component.exports